<template>
  <div class="detail-tab-content">
    <div class="title">其他垃圾投递</div>
    <div class="content">
      <wt-form-table :key="4" :form.sync="form"></wt-form-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralUserViewOtherDelivery',
  isAutoComponent: true,
  props: ['id'],
  data() {
    return {
      form: {
        isFormLoading: false,
        formComponent: {
          list: { type: 'default', value: '/modules/userDeliveryOther/userDeliveryOtherListByUserId', params: { id: 0 }}
        },
        formInputsData: [],
        formButtonsData: [],
        formTableData: [
          { name: '物品名称', key: 'garbageName', type: 'text' },
          { name: '投递总量（个）', key: 'garbageCount', type: 'text' },
          { name: '总积分', key: 'garbageTotalPrice', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true, searchButtonHidden: true }
      }
    }
  },
  created() {
    this.form.formComponent.list.params.id = this.id
  }
}
</script>

<style>
</style>
